export default "__VITE_ASSET__DIiPU4iH__"